'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _StepBase2 = require('../StepBase');

var _StepBase3 = _interopRequireDefault(_StepBase2);

var _FreeProducts = require('./FreeProducts');

var _FreeProducts2 = _interopRequireDefault(_FreeProducts);

var _sticky = require('linksoft-albatros/src/components/sticky');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _SummaryBox = require('../step3/SummaryBox');

var _SummaryBox2 = _interopRequireDefault(_SummaryBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    return {
        cart: state.cart,
        freeProducts: state.cart.freeProducts || [],
        selectedFreeProducts: options.selectedFreeProducts || [],
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon)
    };
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    updateFreeProducts: _actions2.default.updateFreeProducts
};

var FreeProductSelectionStep = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_StepBase) {
    (0, _inherits3.default)(FreeProductSelectionStep, _StepBase);

    function FreeProductSelectionStep(props) {
        (0, _classCallCheck3.default)(this, FreeProductSelectionStep);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FreeProductSelectionStep.__proto__ || (0, _getPrototypeOf2.default)(FreeProductSelectionStep)).call(this, props, 2));

        _this.freeProductSelected = function (e) {
            return _this.props.updateFreeProducts(e.campaignId, e.realCampaignId, e.selectedId, parseInt(e.amount), e.unselectedId);
        };

        return _this;
    }

    (0, _createClass3.default)(FreeProductSelectionStep, [{
        key: 'nextStep',
        value: function nextStep() {
            var _this2 = this;

            if (this.props.processing) return;
            setTimeout(function () {
                var processing = _this2.props.processing;

                if (processing) return;

                (0, _get3.default)(FreeProductSelectionStep.prototype.__proto__ || (0, _getPrototypeOf2.default)(FreeProductSelectionStep.prototype), 'nextStep', _this2).call(_this2);
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                freeProducts = _props.freeProducts,
                selectedFreeProducts = _props.selectedFreeProducts,
                processing = _props.processing,
                cart = _props.cart;


            var nextStepClass = 'btn btn--lg btn--green';
            if (processing) nextStepClass += ' btn--inactive';

            var cartPrice = cart.totalPrice.finalPrice;

            var allProducts = freeProducts.reduce(function (ar, campaign) {
                return ar.concat(campaign.freeProducts);
            }, []);

            var freeProductsPrice = selectedFreeProducts.reduce(function (prev, cur) {

                var product = allProducts.find(function (p) {
                    return p.productId == cur.productId && cur.discountCampaignId == p.discountCampaignId;
                });

                if (!product) {
                    return prev;
                }

                return prev + cur.amount * product.minOrderPrice;
            }, 0);

            return _react2.default.createElement(
                'div',
                { className: 'step__inner step__inner--3' },
                _react2.default.createElement(
                    'div',
                    { className: 'cart__wrap' },
                    _react2.default.createElement(_FreeProducts2.default, {
                        products: freeProducts,
                        selectedProducts: selectedFreeProducts,
                        onChange: this.freeProductSelected,
                        canPickMultipleFreeProductsPerCampaign: cart.canPickMultipleFreeProductsPerCampaign,
                        amountToSpend: cartPrice - freeProductsPrice })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart__aside' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-summary pt-2' },
                        _react2.default.createElement(_SummaryBox2.default, { cart: this.props.cart }),
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center mt-3' },
                            _react2.default.createElement(
                                'button',
                                { id: 'cartStep1Submit', className: nextStepClass, onClick: function onClick() {
                                        return _this3.nextStep();
                                    } },
                                Resx.App.NextStep,
                                _react2.default.createElement('i', { className: 'icon--arrow-right icon--arrow-right--after' })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mt-5 text-center' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn--sm', onClick: function onClick() {
                                    return _this3.prevStep();
                                } },
                            '< ',
                            Resx.Common.Back
                        )
                    )
                )
            );
        }
    }]);
    return FreeProductSelectionStep;
}(_StepBase3.default), _class2.propTypes = {
    freeProducts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    selectedFreeProducts: _propTypes2.default.arrayOf(_propTypes2.default.object),
    processing: _propTypes2.default.bool,

    empty: _propTypes2.default.func.isRequired,
    setStep: _propTypes2.default.func.isRequired,
    updateFreeProducts: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = FreeProductSelectionStep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/Step.js
// module id = 1137
// module chunks = 0